import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["formCard", "formTitle", "formCardBody", "cpfInput", "birthdateInput", "nameInput", "saveBtn", "errorMessage",
                    "sexDropdown", "sexDropdownBtn", "sexInput", "sexList"]

  connect() {
    this.controllerName = `users--accounts--entities--save`
    this.search = true
    // this.doAccountFormHtml()
  }

  saveAccount() {
    this.stopAccountRefreshing()
    this.getControllerByIdentifier(`app--helpers--pre-modal`).openProcessModal()
    this.send_data = { current_user: {}, account: {}, kind: {} }
    this.saveBtnTarget.disabled = true

    if (this.actionMode == "edit") {
      this.send_data.account.id = this.current_account.id
    }
    this.send_data.account.name = this.nameInputTarget.value.trim()
    this.send_data.account.sex = this.sexInputTarget.dataset.sex
    this.send_data.account.cpf = this.getControllerByIdentifier("app--helpers--numbers").fromCpfToNumber(this.cpfInputTarget.value.trim())
    this.send_data.account.birthdate = this.getControllerByIdentifier("app--helpers--date").transformAllKindDate(this.birthdateInputTarget.value)
    this.send_data.kind.kind = this.kind

    this.send_data.current_user.current_user_id = this.application.current_user.id
    this.send_data.current_user.feature = `account_entities`

    this.requestSave()
  }

  requestSave() {
    if (this.actionMode == "new") {
      var url = "/users/accounts/entities/create"
      var method = "POST"
    } else if (this.actionMode == "edit") {
      var url = "/users/accounts/entities/update"
      var method = "PUT"
    }
    const init = { method: method, credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(this.send_data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        controller.stopRefreshing()
        if (response.save) {
          var account = response.data.cln
          if (this.actionMode == `new`) {
            controller.application.accounts[controller.application.accounts.length] = account
          } else if (this.actionMode == `edit`) {
            controller.application.accounts.forEach((element, i) => {
              if (element.id == account.id) {
                controller.application.accounts.splice(controller.application.accounts.indexOf(element), 1, account)
              }
            })
          }

          controller.cancelSave()
          controller.getControllerByIdentifier("users--accounts--entities--index").doDataTable()
        } else {
          controller.saveBtnTarget.disabled = false
          if (controller.hasDeleteBtnTarget) {
            controller.deleteBtnTarget.disabled = true
          }
        }
        controller.getControllerByIdentifier("app--helpers--snackbar").doSnackbar(response.type, response.message, 2000)
        controller.getControllerByIdentifier(`app--helpers--pre-modal`).closeProcessModal()
      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--pre-modal`).closeProcessModal()
        controller.getControllerByIdentifier("app--helpers--console").console(error)
        controller.getControllerByIdentifier("app--helpers--snackbar").doSnackbar("danger", controller.getControllerByIdentifier("app--helpers--messages").generalError(), 3000)
      })
  }

  cancelSave() {
    this.getControllerByIdentifier("users--accounts--entities--dashboard").doMainDashboard()
  }

  doFormHtml() {
    this.stopRefreshing()

    var html = `<div class="col-12">
                  <div class="card" style="width:100%;display:relative;" data-${this.controllerName}-target="formCard" data-action="resize@window->${this.controllerName}#layout">
                    <div class="card-header d-flex align-items-center card-header-table-list f-065">
                      <h6 class="card-title display-4" style="padding:1rem;font-size:110%;margin-bottom:0px;" data-${this.controllerName}-target="formTitle">Criando Nova Conta Tipo: ${this.kind_pretty}</h6>
                    </div>
                    <div class="card-body py-0" style="overflow:auto;" data-${this.controllerName}-target="formCardBody">
                      <div class="row my-2">
                        <div class="col-4 px-2">
                          <div class="form-group">
                            <div class="floating-label floating-label-sm">
                              <label for="cpfForm">CPF</label>
                              <input aria-describedby="cpfFormHelp" class="form-control form-valid-control" id="cpfForm" data-${this.controllerName}-target="cpfInput" data-action="blur->${this.controllerName}#cpfMask keypress->${this.controllerName}#cpfMask keyup->${this.controllerName}#cpfValidate blur->${this.controllerName}#cpfValidate keyup->${this.controllerName}#searchAccount blur->${this.controllerName}#searchAccount" placeholder="CPF Tomador" type="text" required>
                            </div>
                          </div>
                        </div>
                        <div class="col-8 px-2">
                          <div class="form-group">
                            <div class="floating-label floating-label-sm">
                              <label for="nameForm">Nome</label>
                              <input aria-describedby="nameFormHelp" class="form-control form-valid-control" id="nameForm" data-${this.controllerName}-target="nameInput" placeholder="Nome Tomador" type="text" required>
                            </div>
                          </div>
                        </div>

                      </div>

                      <div class="row my-2">
                        <div class="col-4 px-2">
                          <div class="form-group">
                            <div class="floating-label floating-label-sm">
                              <label for="birthdateForm">Data Nascimento</label>
                              <input aria-describedby="birthdateFormHelp" class="form-control form-valid-control" id="birthdateForm" data-action="blur->${this.controllerName}#dateMask keypress->${this.controllerName}#dateMask keyup->${this.controllerName}#dateValidate blur->${this.controllerName}#dateValidate" data-${this.controllerName}-target="birthdateInput" placeholder="DD/MM/AAAA" type="text" required>
                            </div>
                          </div>
                        </div>
                        <div class="col-4 px-2">
                          <div class="form-group">
                            <div class="floating-label floating-label-sm">
                              <label>Sexo</label>
                              <div class="dropdown dropdown-selector" data-controller="app--helpers--search app--helpers--selector" data-app--helpers--selector-target="dropdown" data-${this.controllerName}-target="sexDropdown">
                                <button class="dropdown-toggle form-control d-flex" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="height:32px;" data-app--helpers--selector-target="btn" data-${this.controllerName}-target="sexDropdownBtn"><span class="mr-auto w-100 selected-item" data-app--helpers--selector-target="input" data-${this.controllerName}-target="sexInput"></span></button>
                                <div class="dropdown-menu dropdown-menu-selector w-100 box-shadow-selector">
                                  <input class="form-control form-control-selector" data-app--helpers--search-target="searchInput" data-action="keyup->app--helpers--search#doSearchList" type="text" placeholder="Buscar ...">
                                  <ul class="ul-select" data-${this.controllerName}-target="sexList" data-app--helpers--search-target="searchList">
                                    <li data-sex="male" data-action="click->app--helpers--selector#select" data-app--helpers--selector-target="select" class="li-selector dark f-065">Masculino</li>
                                    <li data-sex="female" data-action="click->app--helpers--selector#select" data-app--helpers--selector-target="select" class="li-selector dark f-065">Feminino</li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                    <div class="card-footer border-top text-right py-1">
                      <span class="mr-auto text-left f-danger my-auto" data-${this.controllerName}-target="errorMessage"></span>
                      <button type="button" class="btn btn-secondary btn-sm py-2 f-065" data-action="click->${this.controllerName}#cancelSave">Fechar</button>
                      <button type="button" class="btn btn-primary btn-sm py-2 f-065" data-action="click->${this.controllerName}#saveAccount" data-${this.controllerName}-target="saveBtn">Salvar</button>
                    </div>
                  </div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier("users--accounts--entities--dashboard").viewTarget.innerHTML = html)
    }).then(() => {
      controller.refreshSaveBtn()
      controller.formCardTarget.style.height = ($(window).height() * 0.5) + "px"

      if (controller.actionMode == `new`) {

        controller.nameInputTarget.disabled = true
        controller.birthdateInputTarget.disabled = true

      } else if (controller.actionMode == `edit`) {
        controller.cpfInputTarget.value = controller.current_account.cpf_pretty
        controller.nameInputTarget.value = controller.current_account.name
        
        if (controller.current_account.birthdate) {
          controller.birthdateInputTarget.value = controller.current_account.birthdate_pretty
        }

        controller.sexInputTarget.innerText = controller.current_account.sex_pretty
        controller.sexInputTarget.dataset.sex = controller.current_account.sex
        controller.sexDropdownTarget.value = controller.current_account.sex

        controller.saveBtnTarget.classList.remove(`d-none`)
      }

      controller.getControllerByIdentifier("app--helpers--forms").floatingLabel()
    })
  }

  cpfMask(ev) {
    this.getControllerByIdentifier("app--helpers--numbers").changeNumberToCpf(ev)
  }

  dateMask(ev) {
    this.getControllerByIdentifier("app--helpers--numbers").changeNumberToDate(ev)
  }

  dateValidate(ev) {
    var cleanDate = this.getControllerByIdentifier("app--helpers--numbers").fromDateToNumber(ev.target.value)
    if ((ev.type == "keyup" && ev.shiftKey == false && cleanDate.length == 8) || ev.type == "blur" && cleanDate.length == 8) {
      this.checkDate = this.getControllerByIdentifier("app--helpers--date").checkDate(ev.target.value)
      if (this.checkDate.valid) {
        this.birthdateInputTarget.classList.add("f-normal")
        this.birthdateInputTarget.classList.remove("f-danger")
      } else {
        this.getControllerByIdentifier("app--helpers--snackbar").doSnackbar("danger", this.checkDate.message, 3000)
        this.birthdateInputTarget.classList.add("f-danger")
        this.birthdateInputTarget.classList.remove("f-normal")
      }
    } else {
      this.birthdateInputTarget.classList.add("f-normal")
      this.birthdateInputTarget.classList.remove("f-danger")
    }
  }

  cpfValidate(ev) {
    var cleanCpf = this.getControllerByIdentifier("app--helpers--numbers").fromCpfToNumber(ev.target.value)
    if ((ev.type == "keyup" && ev.shiftKey == false && cleanCpf.length == 11) || ev.type == "blur" && cleanCpf.length == 11) {
      this.cpf_result = this.getControllerByIdentifier("app--helpers--tax-number").cpf_validate(ev.target.value)
      if (this.cpf_result.invalid) {
        this.getControllerByIdentifier("app--helpers--snackbar").doSnackbar("danger", this.cpf_result.message, 3000)
        this.cpfInputTarget.classList.add("f-danger")
        this.cpfInputTarget.classList.remove("f-normal")
      } else {
        this.cpfInputTarget.classList.add("f-normal")
        this.cpfInputTarget.classList.remove("f-danger")
      }
    } else if ((ev.type == "keyup" && ev.shiftKey == false && cleanCpf.length > 11) || ev.type == "blur" && cleanCpf.length > 11) {
      this.getControllerByIdentifier("app--helpers--snackbar").doSnackbar("danger", `CPF Inválido`, 3000)
      this.cpfInputTarget.classList.add("f-danger")
      this.cpfInputTarget.classList.remove("f-normal")
    } else {
      this.cpfInputTarget.classList.add("f-normal")
      this.cpfInputTarget.classList.remove("f-danger")
    }
  }

  searchAccount(ev) {
    ev.preventDefault()
    ev.stopPropagation()
    var cleanCpf = this.getControllerByIdentifier("app--helpers--numbers").fromCpfToNumber(ev.target.value)
    if (ev.type == "keyup" && cleanCpf.length < 11) {
      this.nameInputTarget.value = ""
      this.birthdateInputTarget.value = ""
      this.sexDropdownTarget.value = ""
      this.sexInputTarget.innerText = ""
      this.sexInputTarget.dataset.sex = ""

      this.nameInputTarget.disabled = false
      this.birthdateInputTarget.disabled = false
      this.sexDropdownBtnTarget.disabled = false


      // } else if ((ev.type == "keyup" && ev.shiftKey == false && cleanCpf.length == 14) || ev.type == "blur" && cleanCpf.length == 14 && this.nameInputTarget.value == "") {
    } else if (ev.type == "keyup" && ev.shiftKey == false && cleanCpf.length == 11 && this.search) {
      this.search = false
      this.cpf_result = this.getControllerByIdentifier("app--helpers--tax-number").cpf_validate(ev.target.value)
      // this.cpf_result = {}
      // this.cpf_result.invalid = false
      var data = { account: { cpf: cleanCpf, kind: "" }, current_user: { current_user_id: this.application.current_user.id, feature: "account_entities" } }
      const url = "/users/accounts/entities/read"
      const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
      if (this.cpf_result.invalid == false) {
        var hasAccount = this.checkIfExist(cleanCpf)
        if (hasAccount) {
          this.setErrorMessage("A Pessoa já está cadastrada!")
          this.saveBtnTarget.remove()
        } else {
          var controller = this
          fetch(url, init)
            .then(response => response.json())
            .then(response => {
              this.search = true
              if (response.process) {
                controller.account = response.data.cln

                if (controller.account.id) {
                  controller.nameInputTarget.value = controller.account.name
                  controller.sexInputTarget.innerText = controller.account.sex_pretty
                  controller.sexInputTarget.dataset.sex = controller.account.sex
                  controller.sexDropdownTarget.value = controller.account.sex
                  if (controller.account.birthdate_pretty) {
                    controller.birthdateInputTarget.value = controller.account.birthdate_pretty
                  } else {
                    controller.birthdateInputTarget.value = ``
                  }

                  controller.nameInputTarget.disabled = false
                  controller.sexDropdownBtnTarget.disabled = false
                  controller.birthdateInputTarget.disabled = false

                  controller.saveBtnTarget.classList.remove("d-none")
                  controller.saveBtnTarget.innerText = `Confirmar`
                  controller.actionMode = `edit`
                } else {
                  // controller.formTitleTarget.innerText = `Criando PJ Médica`
                  controller.nameInputTarget.value = "Favor adicionar o Nome"

                  controller.nameInputTarget.disabled = false
                  controller.sexDropdownBtnTarget.disabled = false
                  controller.birthdateInputTarget.disabled = false

                  controller.saveBtnTarget.classList.remove("d-none")
                  controller.saveBtnTarget.innerText = `Salvar`
                  controller.actionMode = `new`
                }

                controller.getControllerByIdentifier("app--helpers--forms").floatingLabel()
              } else {
                controller.getControllerByIdentifier("app--helpers--snackbar").doSnackbar(response.type, response.message, 2000)
              }
            })
            .catch(error => {
              controller.getControllerByIdentifier("app--helpers--console").console(error)
              controller.getControllerByIdentifier("app--helpers--snackbar").doSnackbar("danger", controller.getControllerByIdentifier("app--helpers--messages").generalError(), 3000)
            })
        }

      }

    }
  }

  checkIfExist(cpf) {
    var diffAccount = true
    var hasAccount = false
    this.application.accounts.forEach(element => {
      if (element.cpf == cpf) {
        this.nameInputTarget.value = element.name
        this.birthdateInputTarget.value = element.birthdate_pretty
        this.sexInputTarget.innerText = element.sex_pretty
        this.sexInputTarget.dataset.sex = element.sex
        this.sexDropdownTarget.value = element.sex
        this.setErrorMessage("A Conta já está cadastrada!")
        diffAccount = false
        hasAccount = true
        this.getControllerByIdentifier("app--helpers--forms").floatingLabel()
      } else {
        if (diffAccount) {
          diffAccount = true
          hasAccount = false
        }
      }
    });

    return hasAccount
  }

  setErrorMessage(message) {
    this.errorMessageTarget.innerText = message
    var controller = this
    setTimeout(() => {
      controller.errorMessageTarget.innerText = ``
    }, 3000);
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  layout() {
    var targets = ["mainCard"]
    var identifier = ""
    // this.getControllerByIdentifier("app--helpers--layout").resizeMainCard(targets, identifier)
  }

  refreshSaveBtn() {
    var controller = this
    this.refreshAccountTimer = setInterval(function () {
      var len = 0

      if (controller.hasFormCardTarget) {
        if (controller.cpf_result && controller.cpf_result.invalid) {
          len += 1
        }
        
        if (controller.cpfInputTarget.value == ``) {
          len += 1
        }
        
        if (controller.nameInputTarget.value == `` || controller.nameInputTarget.value == `Favor adicionar o Nome`) {
          
          len += 1
        }
        
        // if (controller.birthdateInputTarget.value == ``) {
        //   len += 1
        // }
        
        if (controller.sexInputTarget.innerText == ``) {
          len += 1
        }
        
        if (controller.hasSaveBtnTarget) {
          if (len == 0) {
            controller.saveBtnTarget.disabled = false
          } else {
            controller.saveBtnTarget.disabled = true
          }
        }
      }
    }, 200);

  }

  stopRefreshing() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  }

  stopAccountRefreshing() {
    if (this.refreshAccountTimer) {
      clearInterval(this.refreshAccountTimer)
    }
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
